"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repositorySearch = exports.repositoryExists = void 0;

var _path = _interopRequireDefault(require("path"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var repositoryExists = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var owner, repository, config, uid, params, url, repos, repo;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            owner = _ref.owner, repository = _ref.repository, config = _ref.config;
            _context.next = 3;
            return (0, _.getUID)({
              username: owner,
              config: config
            });

          case 3:
            uid = _context.sent;
            params = {
              q: repository,
              uid: uid
            };
            url = _path.default.join(_.apiPath, 'repos', 'search');
            _context.next = 8;
            return (0, _.get)({
              url: url,
              params: params,
              config: config
            });

          case 8:
            repos = _context.sent;
            repo = repos.filter(function (_repo) {
              return _repo.name === repository;
            })[0];
            return _context.abrupt("return", !!repo);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function repositoryExists(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.repositoryExists = repositoryExists; // /repos/search?q=ulb&uid=4598&limit=50&exclusive=true

var repositorySearch = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var owner, query, config, _query, repositories, params, url, response, _repositories;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            owner = _ref3.owner, query = _ref3.query, config = _ref3.config;
            _query = query;

            if (_query) {
              _query = _query.replace(/_/g, '\\_');
              _query = _query.replace(/\s+/g, '%');
              _query = _query.replace(/\*/g, '_');
            }

            repositories = [];
            params = {
              q: _query,
              limit: 50
            };
            if (owner) url = _path.default.join(_.apiPath, 'users', owner, 'repos');else url = _path.default.join(_.apiPath, 'repos', 'search');
            _context2.prev = 6;
            _context2.next = 9;
            return (0, _.get)({
              url: url,
              params: params,
              config: config
            });

          case 9:
            response = _context2.sent;
            repositories = response.data || response;
            _context2.next = 16;
            break;

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](6);
            repositories = [];

          case 16:
            _repositories = repositories.filter(function (repo) {
              return repo.name.match(query);
            });
            return _context2.abrupt("return", _repositories);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 13]]);
  }));

  return function repositorySearch(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.repositorySearch = repositorySearch;